import React, { Component } from "react";
import history from "../Utils/History";
import { connect } from "react-redux";
import {
  fetch_customer_language_locales,
  VERDA_CONSTS,
} from "../Utils/StaticData/Constant";
import {
  guestLogin,
  yearSelection,
  setDeepLink,
  getZipCodes,
  getPlansEmail,
  setStateParams,
  setLoginStateParams,
  planSelectionContinue,
  setFormData,
  getAgentIDListInPreEnrollForm,
  comparePlan,
  getPlanDetails,
  getcmpNames,
  setTokenTORedux,
  setPageName,
  setCategoryName,
  getAgencyId,
  getPlans,
  saveAgentDetails
} from "../Redux/Actions/webAppActions";
import { getKeyCloakToken } from "../Redux/Actions/keyCloakAction";
import PlanDetailsTable from "./PlanDetailsTable";
import SupplementDetailsTable from "./SupplementDetailsTable";
import PlanNameDetails from "./PlanNameDetails";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import DescriptionIcon from "@material-ui/icons/Description";
import { withStyles } from "@material-ui/core/styles";
import {
  header,
  header_supplement_Deductible,
  header_supplement_BloodA,
  header_supplement_Hospice,
  header_supplement_BloodB,
  header_supplement_Clinical,
  header_supplement_Home,
  header_supplement_Other,
} from "../Utils/StaticData/WebAppStaticData";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import Button from "@material-ui/core/Button";
import { Text } from "react-internationalization";

const CustomFileCopyIcon = withStyles({
  root: {
    height: "30px",
    width: "30px",
    backgroundColor: "#084266",
    borderRadius: "50%",
    color: "white",
    padding: "5px",
  },
})(FileCopyIcon);
const CustomDescriptionIcon = withStyles({
  root: {
    height: "30px",
    width: "30px",
    backgroundColor: "#084266",
    borderRadius: "50%",
    color: "white",
    padding: "5px",
    // color: "#034ea2"
  },
})(DescriptionIcon);
const CustomButton = withStyles({
  root: {
    boxShadow: "0px 2px 2px 0px rgb(0 0 0 / 75%)",
    margin: "auto",
    backgroundColor: "#0e3570",
    outline: "none",
    color: "white",
    border: "none",
    boxSizing: "border-box",
    padding: "6px 32px",
    fontSize: "16px",
    borderRadius: "50px",
    display: "inline-block",
    fontWeight: "400",
    textAlign: "center",
    verticalAlign: "middle",
    lineHeight: "1.5",
    "&:hover": {
      backgroundColor: "#034ea2",
      boxShadow: "none",
    },
  },
})(Button);
class PlanSelection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prescriptionDisplay: [],
      snackBarOpen: false,
      snackBarMsg: "",
      vertical: "top",
      horizontal: "center",
      snackBarSeverty: "",
    };
    this.displayDetailList = [];
  }
  goBack = async (event) => {
    await this.props.setStateParams("detailsPlanType", "");
    window.sessionStorage.removeItem("cmpnames");
    window.sessionStorage.removeItem("selectedPlansForCompare");
    await this.props.setStateParams("selectedPlansForCompare", []);
    if (this.props.datadeepLink.deeplink === true) {
      this.props.setLoginStateParams("deeplink", false);
      history.push("/e-Enroll/select-plan");
    } else {
      history.goBack();
    }
  };
  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    this.setState({
      snackBarOpen: false,
    });
  };
  printContent = (event) => {
    event.preventDefault();

    window.print();
  };
  async componentWillMount() {
    let queryString = window.location.search;
    let customerId = "";
    let zipCd = "";
    let countyCd = "";
    let stateCd = "";
    let countyName = "";
    let productID = "";
    let username = "";
    let productCategory = "";
    let selectedPlanName = "";
    let year = "";
    let userRole = "";
    let token = "";

    if (queryString.includes("deepLink=true")) {
      let queryStringArray = queryString.split("&");
      queryStringArray.forEach((element) => {
        if (element.includes("customerId")) {
          customerId = window.atob(element.split("=")[1]);
        } else if (element.includes("zipCd")) {
          zipCd = window.atob(element.split("=")[1]);
        } else if (element.includes("countyCd")) {
          countyCd = window.atob(element.split("=")[1]);
        } else if (element.includes("stateCd")) {
          stateCd = window.atob(element.split("=")[1]);
        } else if (element.includes("countyName")) {
          countyName = window.atob(element.split("=")[1]);
        } else if (element.includes("productId")) {
          productID = window.atob(element.split("=")[1]);
        } else if (element.includes("email")) {
          username = window.atob(element.split("=")[1]);
        } else if (element.includes("planYear")) {
          year = window.atob(element.split("=")[1]);
        } else if (element.includes("userRole")) {
          userRole = window.atob(element.split("=")[1]);
        } else if (element.includes("token")) {
          token = element.split("=")[1];
        } else if (element.includes("productCategory")) {
          productCategory = element.split("=")[1];
        } else if (element.includes("selectedPlanName")) {
          selectedPlanName = window.atob(element.split("=")[1]);
        }
      });
      // SONAR let index = 0;
      // if (queryString.includes("deepLink=true")) {
      //   let queryStringArray = queryString.split("&");
      //   if (queryStringArray[1].includes("customerId")) {
      //     customerId = window.atob(queryStringArray[1].split("=")[1]);
      //   }
      //   if (queryStringArray[2].includes("zipCd")) {
      //     zipCd = window.atob(queryStringArray[2].split("=")[1]);
      //   }
      //   if (queryStringArray[3].includes("countyCd")) {
      //     countyCd = window.atob(queryStringArray[3].split("=")[1]);
      //   }

      //   if (queryStringArray[4].includes("stateCd")) {
      //     stateCd = window.atob(queryStringArray[4].split("=")[1]);
      //   }

      //   if (queryStringArray[5].includes("countyName")) {
      //     countyName = window.atob(queryStringArray[5].split("=")[1]);
      //   }

      //   if (queryStringArray[6].includes("productId")) {
      //     productID = window.atob(queryStringArray[6].split("=")[1]);
      //   }
      //   if (queryStringArray[7].includes("email")) {
      //     username = window.atob(queryStringArray[7].split("=")[1]);
      //   }
      //   if (queryStringArray[10].includes("productCategory")) {
      //     productCategory = window.atob(queryStringArray[10].split("=")[1]);
      //   }
      //   if (queryStringArray[11].includes("selectedPlanName")) {
      //     selectedPlanName = window.atob(queryStringArray[11].split("=")[1]);
      //   }
      //   if (queryStringArray[12].includes("planYear")) {
      //     year = window.atob(queryStringArray[12].split("=")[1]);
      //   }
      //   if (queryStringArray[13].includes("userRole")) {
      //     userRole = window.atob(queryStringArray[13].split("=")[1]);
      //   }
      //   if (queryStringArray[14]?.includes("token")) {
      //     token = queryStringArray[14].split("=")[1];
      //   }
      // console.log("isDeepluserRoleink",queryStringArray)

      if (
        (userRole === "beneficiary" || userRole === "agent") &&
        !window.sessionStorage.getItem("isDeeplink")
      ) {
        window.sessionStorage.setItem("isDeeplink", window.location.href);
        window.sessionStorage.setItem("isDeepEmail", username);
        history.push("/e-Enroll/UserLogin");
        return;
      } else if (userRole === "guest") {
        await this.props.setLoginStateParams("dpemail", username);
        let guestpayload = {
          customerId: customerId,
          username: this.props.dpemail,
        };
        const guestLoginDetails = await this.props.guestLogin(guestpayload);
        await this.props.setTokenTORedux(guestLoginDetails.data.token);
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + guestLoginDetails.data.token
        );
      } else if (userRole === "beneficiary") {
        if (!window.sessionStorage.getItem("token")) {
          window.sessionStorage.setItem("isDeeplink", window.location.href);
          window.sessionStorage.setItem("isDeepEmail", username);
          history.push("/e-Enroll/UserLogin");
          return;
        }
        this.props.setLoginStateParams("beneficiaryLogin", true);

        await this.props.setTokenTORedux(
          window.sessionStorage.getItem("token")
        );
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + window.sessionStorage.getItem("token")
        );
        window.sessionStorage.removeItem("isDeeplink");
        window.sessionStorage.removeItem("isDeepEmail");
      } else if (userRole === "agent") {
        if (token === "") {
          window.sessionStorage.setItem("isDeeplink", window.location.href);
          window.sessionStorage.setItem("isDeepEmail", username);
          history.push("/e-Enroll/UserLogin");
          return;
        }
        //this.props.setTokenTORedux(token);
        this.props.setLoginStateParams("temporaryKeyCloaktoken", token);
        this.props.setLoginStateParams("agentLoggedIn", true);
        window.sessionStorage.setItem("agentLoggedIn", true);
        window.sessionStorage.removeItem("isDeeplink");
        window.sessionStorage.removeItem("isDeepEmail");
        const response = await this.props.getKeyCloakToken();
        window.sessionStorage.setItem(
          "keyCloakData",
          JSON.stringify(response.data)
        );
        await this.props.setStateParams("roles", response.data.roles);
        window.sessionStorage.setItem("token", response.data.token);
        this.props.setTokenTORedux(response.data.token);
        await this.props.setLoginStateParams(
          "agentEmailId",
          response.data.agentDetails?.agentEmail
        );
        await this.props.getAgencyId(
          response?.data?.agentId,
          window.sessionStorage.getItem("customerId")
        );
        await this.props.getZipCodes(zipCd);
        await this.props.getPlansEmail(
          zipCd,
          countyCd,
          customerId,
          stateCd,
          year,
          "Bearer " + response.data.token
        );
        let isAgentRole = false;
        let isSuperUser = false;
        for (let i = 0; i < response.data.roles?.length; i++) {
          if (response.data.roles[i] === "AGENT") {
            isAgentRole = true;
          }
          if (
            response.data.roles[i] === "SUPER_USER" ||
            response.data.roles[i] === "AGENCY_ADMIN"
          ) {
            isSuperUser = true;
          }
        }
        window.sessionStorage.setItem(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        await this.props.setLoginStateParams(
          "agencyIDSelected",
          this.props.agencyID[0].value?.trim()
        );
        await this.props.setStateParams("isAgentRole", isAgentRole);
        await this.props.setStateParams("isSuperUser", isSuperUser);
        window.sessionStorage.setItem("isSuperUser", isSuperUser);
        window.sessionStorage.setItem("isAgentRole", isAgentRole);
      }
      this.props.yearSelection(year);
      await this.props.setDeepLink({
        deeplink: true,
        countyName: countyName,
        zipcode: zipCd,
        productId: productID,
        stateCd: stateCd,
        email: username,
      });
      window.sessionStorage.setItem(
        "selectedPlansForCompare",
        JSON.stringify(productID.split(","))
      );
      this.props.setLoginStateParams("deeplinkflag", true);
      this.props.setStateParams("zip", zipCd);

      let productidArray = this.props.datadeepLink.dpProductId.split(",");
      let cmppayload = [];
      for (let i = 0; i < productidArray.length; i++) {
        cmppayload[i] = this.props.dataSet.planCardData.filter(
          (data1) => data1.productId.trim() === productidArray[i]
        )[0];
      }
      this.props.setStateParams("cmpnames", cmppayload);
      if (cmppayload.length > 1) {
        const list = cmppayload?.map((plan) => ({
          customerId: this.props?.customerId,
          planId: plan.planId,
          productId: plan.productId,
          planName: plan.planName,
          planYear: year ? year : window.sessionStorage.getItem("year"),
        }));
        await this.props.comparePlan(list);
      }
      if (cmppayload.length === 1) {
        await this.props.setLoginStateParams("selectedPlan", productID);
        await this.props.setLoginStateParams("productId", productID);
        let singlePlanDetails = this.props.dataSet.planCardData.filter(
          (x) => x.productId === this.props.productId
        );
        this.props.setStateParams("singlePlanDetails", singlePlanDetails);
        const { planId, pbpId, productName } =
          this.props.dataSet.planCardData.filter(
            (data1) => data1.productId.trim() === productID?.trim()
          )[0];
        await this.props.setStateParams("planSelected", { planId, pbpId });
        await this.props.setStateParams("product", productName);
        await this.props.getPlanDetails(
          this.props?.customerId,
          productID,
          this.props.year
        );
        await this.props.setCategoryName(productCategory, selectedPlanName);
      }

      history.push("/e-Enroll/compare-plan");
    }
    if (this.props.token === "" || this.props.token === undefined) {
      let plans = [];
      plans = JSON.parse(window.sessionStorage.getItem("cmpnames"));

      if (
        this.props.emailAddress === "" ||
        this.props.firstName === "" ||
        this.props.email === "" ||
        this.props.agentEmailId === undefined
      ) {
        if (window.sessionStorage.getItem("agentLogin") === "true") {
          this.props.setLoginStateParams(
            "agentEmailId",
            window.sessionStorage.getItem("email")
          );
          this.props.setLoginStateParams(
            "firstName",
            window.sessionStorage.getItem("firstName")
          );
          this.props.setLoginStateParams("agentLoggedIn", true);
          this.props.setLoginStateParams(
            "agentId",
            window.sessionStorage.getItem("agentId")
          );
          this.props.setLoginStateParams(
            "agencyIDSelected",
            window.sessionStorage.getItem("agencyId")
          );
          this.props.setStateParams("guestLoggedIn", false);
          this.props.setLoginStateParams("guestLogin", false);
        }
        if (
          window.sessionStorage.getItem("guestLogin") === "false" &&
          window.sessionStorage.getItem("agentLogin") === "false"
        ) {
          this.props.setLoginStateParams(
            "emailAddress",
            window.sessionStorage.getItem("email")
          );
          this.props.setLoginStateParams(
            "firstName",
            window.sessionStorage.getItem("firstName")
          );
          this.props.setStateParams("guestLoggedIn", false);
          this.props.setLoginStateParams("guestLogin", false);
          this.props.setLoginStateParams(
            "authenticatedData",
            JSON.parse(window.sessionStorage.getItem("authenticatedData"))
          );
        }
      }
      this.props.setStateParams("year", new Date().getFullYear().toString());
      if (this.props.token === "" || this.props.token === undefined) {
        await this.props.setTokenTORedux(
          window.sessionStorage.getItem("token")
        );
      }
      if (plans?.length === 1) {
        let formPayload = {
          planId: plans[0].planId,
          productId: plans[0].productId,
          premiumAmount: plans[0].monthlyPremium,
          planName: plans[0].planName,
        };
        this.props.setFormData(formPayload);
      }
      this.props.getcmpNames(plans);
      const list = plans?.map((plan) => ({
        customerId: this.props?.customerId,
        planId: plan.planId,
        productId: plan.productId,
        planName: plan.planName,
        planYear: year ? year : window.sessionStorage.getItem("year"),
      }));
      await this.props.comparePlan(list);
       if (this.props.dataSet.planCardData.length === 0) {
        await this.props.getZipCodes(
          this.props.zipCode
            ? this.props.zipCode
            : window.sessionStorage.getItem("zipcode")
        );
        let codes = this.props.zipCodes.filter((item)=>item.countyName===window.sessionStorage.getItem("countySelect"))
        await this.props.getPlans(
          this.props.zipCode
            ? this.props.zipCode
            : window.sessionStorage.getItem("zipcode"),
          codes[0].countyCode,
          this.props?.customerId,
          this.props.stateCd,
          this.props.year
        );
        const agentData = JSON.parse(window.sessionStorage.getItem("keyCloakData")).agentDetails
        this.props.setLoginStateParams("agentId", agentData?.agentId?.trim());
        this.props.setLoginStateParams("agentPhone", agentData.agentPhone);
        this.props.setLoginStateParams("agentFullName", agentData?.agentName?.trim());
       }
    }
  }
  componentDidMount() {
    this.props.setPageName("compare-plan");
    let singlePlanDetails = this.props.dataSet.planCardData.filter(
      (x) => x.productId === this.props.productId
    );

    this.props.setStateParams("singlePlanDetails", singlePlanDetails);
  }
  copyLink = (e) => {
    e.preventDefault();
    const dummy = document.createElement("p");
    //let productId="";
    let productIds = "";
    if (Object.keys(this.props.dataSet.plandetails).length > 1) {
      for (
        let i = 0;
        i < Object.keys(this.props.dataSet.plandetails).length;
        i++
      ) {
        productIds = productIds
          ? productIds +
            "," +
            this.props.dataSet.plandetails[i].productId?.trim()
          : productIds + this.props.dataSet.plandetails[i].productId?.trim();
      }
    } else {
      productIds = this.props.datadeepLink.productId?.trim();
    }
    //let productId= Object.keys(this.props.dataSet.plandetails[0]).length>0?this.props.dataSet.plandetails[0].productId?.trim():this.props.productId.trim();
    dummy.textContent =
      //"/e-Enroll/select-plan"
      window.location.href +
      "?" +
      "&" +
      "customerId=" +
      window.btoa(this.props?.customerId) +
      "&" +
      "zipCd=" +
      //this.props.zipCode+
      window.btoa(this.props.dataSet.zip) +
      "&" +
      "countyCd=" +
      //this.props.CountyCd+
      window.btoa(this.props.dataSet.CountyCd) +
      "&" +
      "stateCd=" +
      //this.props.stateCd+
      window.btoa(this.props.dataSet.stateCd) +
      "&" +
      "countyName=" +
      //this.props.countyName.trim()+
      window.btoa(
        typeof this.props.dataSet?.county === "object"
          ? this.props.dataSet?.county?.countyName?.trim()
          : this.props.dataSet?.county?.trim()
      ) +
      "&" +
      "productIds=" +
      // productId.trim()+
      window.btoa(productIds) +
      //this.props.dataSet.plandetails[0].productId.trim()+
      "&" +
      "email=" +
      window.btoa(
        this.props?.emailAddress?.length > 0
          ? this.props?.emailAddress
          : this.props?.email
      ) +
      "&" +
      "deepLink=true" +
      "&" +
      "planCompare=true" +
      "&" +
      "productCategory=" +
      window.btoa(this.props.productCategory) +
      "&" +
      "selectedPlanName=" +
      window.btoa(this.props.selectedPlanName) +
      "&" +
      "planYear=" +
      window.btoa(this.props.year) +
      "&" +
      "userRole=" +
      window.btoa(
        this.props.beneficiaryLogin
          ? "beneficiary"
          : this.props.agentLogin
          ? "agent"
          : "guest"
      ) +
      "&" +
      "lang=" +
      window.btoa(this.props.lang);
    // console.log("querys", this.props.beneficiaryLogin, this.props.agentLogin);
    document.body.appendChild(dummy);

    const range = document.createRange();
    range.setStartBefore(dummy);
    range.setEndAfter(dummy);

    const selection = window.getSelection();
    // // First clear, in case the user already selected some other text
    selection.removeAllRanges();
    selection.addRange(range);

    document.execCommand("copy");
    document.body.removeChild(dummy);
    this.setState({
      snackBarOpen: true,
      snackBarMsg:
        this.props.lang === "es"
          ? "¡Enlace copiado al portapapeles!"
          : "Link Copied to ClipBoard!",
      snackBarSeverty: "info",
    });
    // alert("Link Coppied Successfully!");
  };

  setDetails = (header1, list) => {
    let finArr = [];
    header1.map((head) => {
      list.map((displayDetail, index) => {
        if (head.key === displayDetail.category) {
          let entry = list.splice(index, 1);
          entry[0].category = head.value;
          finArr.push(entry[0]);
        }
      });
    });
    return finArr;
  };

  handleSelect = async (
    event,
    planId,
    planName,
    productName,
    productId,
    productCategory,
    planType
  ) => {
    event.preventDefault();
    await this.props.setStateParams("planType", planType);
    if (this.props.planDetailTable && this.props.planDetailTable.length === 1) {
      productName = this?.props?.planType;
    }
    if (this.props.datadeepLink?.deeplink === false || productName) {
      // some time product name is coming undefined in copy link
      this.props.setStateParams("product", productName?.toUpperCase());
    }
    //else if(productName){
    //   this.props.setStateParams("product", productName?.toUpperCase());
    // }
    let formPayload = {
      planId: planId,
      planName: planName,
      plan: planId,
      productCategory: productCategory ? productCategory : "",
    };
    if (this.props.planDetailTable.length > 1) {
      this.props.setFormData({
        ...formPayload,
        productName: productName,
        productId: productId,
      });
    }

    let payload = {
      productId:
        this.props.planDetailTable.length > 1
          ? productId
          : this.props.productId != ""
          ? this.props.productId
          : this.props.datadeepLink.dpProductId,
      customerId: this.props?.customerId,
    };

    const response = await this.props.planSelectionContinue(
      payload,
      this.props?.customerId
    );
    if (response?.status === "OK") {
      {
        this.props?.agentLogin === true &&
          this.props?.customerId !== VERDA_CONSTS.ID &&
          (await this.props.getAgentIDListInPreEnrollForm(
            this.props?.customerId
          ));
      }
      //not populating the agentname in soa in copy link from details or comparison and then enroll .so given below code
      //  await this.props.setStateParams("pendingApplFlag", false);
      //this.props.setStateParams("isUpdated", false);
      history.push("/e-Enroll/enrollOnline");
    } else {
      this.setState({
        snackBarOpen: true,
        snackBarMsg:
          this.props.lang === "es"
            ? "Por favor, inténtalo después de un tiempo"
            : "Please Try after some time",
        snackBarSeverty: "error",
      });
    }
  };

  render() {
    let dispDetailList = [];
    let prescriptionDisplay = [];
    const { snackBarOpen, snackBarMsg, vertical, horizontal, snackBarSeverty } =
      this.state;
    const { planDetailTable } = this.props;
    this.props.planDetailTable.map((plan, index) => {
      let tempValue = {};
      let headerName = "";

      if (index === 0) {
        Object.entries(plan).map((planEntry) => {
          headerName = header.find((heading) => heading.key === planEntry[0]);
          headerName =
            headerName !== undefined ? headerName.value : planEntry[0];
          tempValue = { category: headerName, description: [] };
          return dispDetailList.push(tempValue);
        });
      }
      Object.entries(plan).forEach((planEntry) => {
        let headerName1 = "";
        dispDetailList.forEach((detail) => {
          headerName1 = header.find((heading) => heading.key === planEntry[0]);
          headerName1 =
            headerName1 !== undefined ? headerName1.value : planEntry[0];
          if (detail.category === headerName1) {
            return detail.description.push(planEntry[1]);
          }
          return {};
        });
      });
    });
    if (this.props.lang === "en") {
      this.displayDetailList = dispDetailList;
      {
        this.displayDetailList.forEach((displayDetail) => {
          {
            displayDetail.category === "Prescription Drugs" &&
              displayDetail.description.map((detail, index1) => {
                {
                  if (index1 === 0) {
                    detail.map((prescriptionDetail, index) => {
                      let tempValue = {};
                      let headerName = "";
                      headerName = header.find(
                        (heading) => heading.key === prescriptionDetail
                      );
                      headerName =
                        headerName !== undefined
                          ? headerName.value
                          : prescriptionDetail;
                      tempValue = { name: headerName, value: [] };
                      prescriptionDisplay.push(tempValue);
                    });
                  }
                  Object.entries(detail).forEach(
                    (prescriptionDetail, index) => {
                      let tempValue = {};
                      prescriptionDisplay.map((prescription) => {
                        let headerName = "";
                        headerName = header.find(
                          (heading) => heading.key === prescriptionDetail
                        );
                        headerName =
                          headerName !== undefined
                            ? headerName.value
                            : prescriptionDetail;

                        if (
                          prescription.name === headerName &&
                          Array.isArray(prescriptionDetail[1])
                        ) {
                          prescriptionDetail[1].map((tierValue, i) => {
                            let tierDesc =
                              i !== 5
                                ? i !== 4
                                  ? i !== 3
                                    ? i !== 2
                                      ? i !== 1
                                        ? "Tier 1 (preffered Generic)"
                                        : "Tier 2 (Generic)"
                                      : "Tier 3 (Preffered Brand)"
                                    : "Tier 4 (Non-preffred Drug)"
                                  : "Tier 5 (Spreciality Tier)"
                                : "Tier 6 (Select Care Drug)";

                            tempValue = {
                              tier: tierDesc,
                              oneM: [tierValue[0]],
                              threeM: [tierValue[1]],
                            };
                            let tier = prescription.value.find(
                              (tierObject) => tierObject.tier === tempValue.tier
                            );
                            let ind = prescription.value.findIndex(
                              (tierObject) => tierObject.tier === tempValue.tier
                            );
                            if (ind !== -1) {
                              tier.oneM.push(tierValue[0]);
                              tier.threeM.push(tierValue[1]);

                              prescription.value.splice(ind, 1, tier);
                            } else prescription.value.push(tempValue);
                          });
                        }
                      });
                    }
                  );
                }
                return;
              });
          }
        });
      }
    } else {
      /*this block used for spanish language of all vanilla version, 
        @ check fetch_customer_language_locales for more detail.
        @ selectedPlansForCompare is an array containing all selected plan's PRODUCTIDs.
        @ It is there in REDUX store  & sesssion storage, used session storage to maintain screen in page load
      */
      let arrs = fetch_customer_language_locales(
        this.props.customerId,
        JSON.parse(window.sessionStorage.getItem("selectedPlansForCompare")) ??
          [],
        this.props.year
      );
      this.displayDetailList = arrs;
    }
    console.log("my-", JSON.stringify(this.displayDetailList));
    //  @@@this log is helpful to copy english data,
    //then convert the JSON to JS Object online, then paste the JS Object in the online translator
    //and check fetch_customer_language_locales for further activity
    let deductible = this.setDetails(
      header_supplement_Deductible,
      this.displayDetailList ?? []
    );
    let bloodA = this.setDetails(
      header_supplement_BloodA,
      this.displayDetailList ?? []
    );
    let hospice = this.setDetails(
      header_supplement_Hospice,
      this.displayDetailList ?? []
    );
    let bloodB = this.setDetails(
      header_supplement_BloodB,
      this.displayDetailList ?? []
    );
    let clinical = this.setDetails(
      header_supplement_Clinical,
      this.displayDetailList ?? []
    );
    let home = this.setDetails(
      header_supplement_Home,
      this.displayDetailList ?? []
    );
    let other = this.setDetails(
      header_supplement_Other,
      this.displayDetailList ?? []
    );

    return (
      <React.Fragment>
        <div class="tab-content-container">
          <Snackbar
            open={snackBarOpen}
            autoHideDuration={3000}
            onClose={this.handleClose}
            anchorOrigin={{ vertical, horizontal }}
            key={vertical + horizontal}
          >
            <Alert onClose={this.handleClose} severity={snackBarSeverty}>
              {snackBarMsg}
            </Alert>
          </Snackbar>
          <div
            id="divcontents"
            class="tab-content container-Cambia margin-top1"
          >
            <div id="ifmcontentstoprint">
              <div class="col-md-12 text-right noprint">
                <CustomButton
                  id="btn_select"
                  variant="contained"
                  onClick={this.goBack}
                >
                  <Text id="plan.goback" />
                </CustomButton>
              </div>
              <div class="display-flex container-Cambia">
                <div
                  class={
                    this.props.planDetailTable.length > 1
                      ? "options container-header fit-content"
                      : "options container-head fit-content"
                  }
                >
                  <ul class="list1">
                    <li class="card_action noprint">
                      <button className="link_buttons" onClick={this.copyLink}>
                        <CustomFileCopyIcon /> <Text id="plan.copylink" />
                      </button>
                    </li>
                    <li class="card_action noprint">
                      <button
                        className="link_buttons"
                        onClick={this.printContent}
                      >
                        <CustomDescriptionIcon />{" "}
                        {this.props.plandetails?.length > 1 ? (
                          <Text id="plan.printc" />
                        ) : (
                          <Text id="plan.printd" />
                        )}
                        {""}
                      </button>
                    </li>
                  </ul>
                </div>
                {planDetailTable.length === 1
                  ? [
                      {
                        totalMonthlyPremium:
                          "$" +
                          (this.props.premiumAmount != ""
                            ? this.props.premiumAmount
                            : this.props.cmpnames[0].monthlyPremium),
                        name:
                          this.props.selectedPlanName != ""
                            ? this.props.selectedPlanName
                            : this.props.cmpnames[0].planName,
                      },
                    ].map((planDetail) => {
                      return <PlanNameDetails data={planDetail} />;
                    })
                  : this.props.cmpnames?.map((planDetail) => {
                      return (
                        <PlanNameDetails
                          data={{
                            totalMonthlyPremium:
                              "$" + planDetail?.monthlyPremium,
                            name:
                              this.props.lang === "es" && planDetail.planNameES
                                ? planDetail.planNameES
                                : planDetail.planName?.toUpperCase(),
                          }}
                        />
                      );
                    })}
              </div>
              <hr />
              <div class="container-Cambia">
                {(this.displayDetailList ?? []).map((displayDetail, index) => {
                  if (
                    !isNaN(displayDetail.category) &&
                    displayDetail.category
                  ) {
                    return null;
                  } else {
                    return (
                      <div>
                        <div class="display-flex fit-content">
                          {displayDetail.category && (
                            <h6
                              class={
                                this.props.planDetailTable.length > 1
                                  ? this.props.plandetails?.length === 3
                                    ? "container-header details-header-mobile-aligner"
                                    : "container-header"
                                  : "container-head"
                              }
                            >
                              {displayDetail.category}
                            </h6>
                          )}
                          {displayDetail.category ? (
                            displayDetail.description.map((detail) => {
                              return (
                                <div className="container-planDetail fit-content">
                                  {detail && Array.isArray(detail)
                                    ? detail.map((_detail) => (
                                        <div>
                                          {
                                            // displayDetail.category.includes(
                                            //   "Doctor Services"
                                            // )
                                            //   ? "$" + _detail
                                            //   :
                                            _detail
                                          }
                                        </div>
                                      ))
                                    : null}
                                </div>
                              );
                            })
                          ) : (
                            <div>
                              {displayDetail.description.length > 0 ? (
                                <React.Fragment>
                                  <h5 class="container-header">
                                    {displayDetail.category}
                                  </h5>
                                  <PlanDetailsTable
                                    displayDetail={prescriptionDisplay}
                                    dispDet={displayDetail.description}
                                  />
                                </React.Fragment>
                              ) : null}
                            </div>
                          )}
                        </div>
                        <hr />
                      </div>
                    );
                  }
                })}
                {this.props.planType &&
                  this.props.planType.includes("supplement") && (
                    <React.Fragment>
                      <hr />
                      <SupplementDetailsTable
                        displayDetailList={deductible}
                        type={"Deductible"}
                      />
                      <SupplementDetailsTable
                        displayDetailList={bloodA}
                        type={"Blood"}
                      />

                      <SupplementDetailsTable
                        displayDetailList={hospice}
                        type={"Hospice Care"}
                      />

                      <SupplementDetailsTable
                        displayDetailList={bloodB}
                        type={"Blood"}
                      />
                      <SupplementDetailsTable
                        displayDetailList={clinical}
                        type={"Clinical Laboratory Services"}
                      />

                      <SupplementDetailsTable
                        displayDetailList={home}
                        type={
                          "Parts A & B Home Health Care — Medicare-Approved Services"
                        }
                      />

                      <SupplementDetailsTable
                        displayDetailList={other}
                        type={"Other Benefits"}
                      />
                    </React.Fragment>
                  )}
              </div>
              <div class="col-md-12 text-right noprint">
                {planDetailTable && planDetailTable.length == 1 && (
                  <div class="noprint">
                    <CustomButton
                      id="btn_select"
                      value={
                        planDetailTable &&
                        planDetailTable[0] &&
                        planDetailTable[0].name
                      }
                      onClick={(e) =>
                        this.handleSelect(
                          e,
                          // planDetailTable[0].planId,
                          // planDetailTable[0].name,
                          // planDetailTable[0]?.productId,
                          // planDetailTable[0]?.productCategory,
                          // planDetailTable[0]?.planType
                          this.props?.singlePlanDetails[0]?.planId,
                          this.props?.singlePlanDetails[0]?.planName,
                          this.props?.singlePlanDetails[0]?.productName,
                          this.props?.singlePlanDetails[0]?.productId,
                          this.props?.singlePlanDetails[0]?.productCategory,
                          this.props?.singlePlanDetails[0]?.planType
                        )
                      }
                    >
                      <Text id="header.enroll" />
                    </CustomButton>
                  </div>
                )}
                {planDetailTable && planDetailTable.length == 2 && (
                  <div class="display-flex fit-content">
                    <h6 class="container-header"></h6>
                    <div class="container-planDetail1 fit-content noprint">
                      <CustomButton
                        id="btn_select"
                        value={
                          planDetailTable &&
                          planDetailTable[0] &&
                          planDetailTable[0].name
                        }
                        onClick={(e) =>
                          this.handleSelect(
                            e,
                            this.props.cmpnames[0]?.planId
                              ? this.props.cmpnames[0]?.planId
                              : this.props.plandetails[0]?.planId,
                            this.props.cmpnames[0]?.planName
                              ? this.props.cmpnames[0]?.planName
                              : this.props.plandetails[0]?.planName,
                            this.props.cmpnames[0]?.productName
                              ? this.props.cmpnames[0]?.productName
                              : this.props.plandetails[0]?.productName,
                            this.props.cmpnames[0]?.productId
                              ? this.props.cmpnames[0]?.productId
                              : this.props.plandetails[0]?.productId,
                            this.props.cmpnames[0]?.productCategory,
                            this.props.cmpnames[0]?.planType
                              ? this.props.cmpnames[0]?.planType
                              : this.props.plandetails[0]?.planType
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </CustomButton>
                    </div>
                    <div class="container-planDetail1 fit-content noprint">
                      <CustomButton
                        id="btn_select"
                        value={
                          planDetailTable &&
                          planDetailTable[1] &&
                          planDetailTable[1].name
                        }
                        onClick={(e) =>
                          this.handleSelect(
                            e,
                            // planDetailTable[1].planId,
                            // planDetailTable[1].name,
                            // planDetailTable[1].productName
                            this.props.cmpnames[1]?.planId
                              ? this.props.cmpnames[1]?.planId
                              : this.props.plandetails[1]?.planId,
                            this.props.cmpnames[1]?.planName
                              ? this.props.cmpnames[1]?.planName
                              : this.props.plandetails[1]?.planName,
                            this.props.cmpnames[1]?.productName
                              ? this.props.cmpnames[1]?.productName
                              : this.props.plandetails[1]?.productName,
                            this.props.cmpnames[1]?.productId
                              ? this.props.cmpnames[1]?.productId
                              : this.props.plandetails[1]?.productId,
                            this.props.cmpnames[1]?.productCategory,
                            this.props.cmpnames[1]?.planType
                              ? this.props.cmpnames[1]?.planType
                              : this.props.plandetails[1]?.planType
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </CustomButton>
                    </div>
                  </div>
                )}
                {planDetailTable && planDetailTable.length == 3 && (
                  <div class="display-flex fit-content button-mobile-margin">
                    <h6 class="container-header"></h6>
                    <div class="container-planDetail1 fit-content noprint">
                      <CustomButton
                        id="btn_select"
                        className="enroll-button-mobile-size"
                        value={
                          planDetailTable &&
                          planDetailTable[0] &&
                          planDetailTable[0].name
                        }
                        onClick={(e) =>
                          this.handleSelect(
                            e,
                            this.props.cmpnames[0]?.planId
                              ? this.props.cmpnames[0]?.planId
                              : this.props.plandetails[0]?.planId,
                            this.props.cmpnames[0]?.planName
                              ? this.props.cmpnames[0]?.planName
                              : this.props.plandetails[0]?.planName,
                            this.props.cmpnames[0]?.productName
                              ? this.props.cmpnames[0]?.productName
                              : this.props.plandetails[0]?.productName,
                            this.props.cmpnames[0]?.productId
                              ? this.props.cmpnames[0]?.productId
                              : this.props.plandetails[0]?.productId,
                            this.props.cmpnames[0]?.productCategory,
                            this.props.cmpnames[0]?.planType
                              ? this.props.cmpnames[0]?.planType
                              : this.props.plandetails[0]?.planType
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </CustomButton>
                    </div>
                    <div class="container-planDetail1 fit-content noprint">
                      <CustomButton
                        id="btn_select"
                        className="enroll-button-mobile-size"
                        value={
                          planDetailTable &&
                          planDetailTable[1] &&
                          planDetailTable[1].name
                        }
                        onClick={(e) =>
                          this.handleSelect(
                            e,
                            this.props.cmpnames[1]?.planId
                              ? this.props.cmpnames[1]?.planId
                              : this.props.plandetails[1]?.planId,
                            this.props.cmpnames[1]?.planName
                              ? this.props.cmpnames[1]?.planName
                              : this.props.plandetails[1]?.planName,
                            this.props.cmpnames[1]?.productName
                              ? this.props.cmpnames[1]?.productName
                              : this.props.plandetails[1]?.productName,
                            this.props.cmpnames[1]?.productId
                              ? this.props.cmpnames[1]?.productId
                              : this.props.plandetails[1]?.productId,
                            this.props.cmpnames[1]?.productCategory,
                            this.props.cmpnames[1]?.planType
                              ? this.props.cmpnames[1]?.planType
                              : this.props.plandetails[1]?.planType
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </CustomButton>
                    </div>
                    <div class="container-planDetail1 fit-content noprint">
                      <CustomButton
                        id="btn_select"
                        className="enroll-button-mobile-size"
                        value={
                          planDetailTable &&
                          planDetailTable[2] &&
                          planDetailTable[2].name
                        }
                        onClick={(e) =>
                          this.handleSelect(
                            e,
                            // planDetailTable[2].planId,
                            // planDetailTable[2].name,
                            // planDetailTable[2].productName
                            this.props.cmpnames[2].planId,
                            this.props.cmpnames[2].planName,
                            this.props.cmpnames[2].productName,
                            this.props.cmpnames[2].productId,
                            this.props.cmpnames[2]?.productCategory,
                            this.props.cmpnames[2]?.planType
                          )
                        }
                      >
                        <Text id="header.enroll" />
                      </CustomButton>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div
          class={
            planDetailTable &&
            planDetailTable.length > 0 &&
            "footer-relative-container"
          }
        >
          {" "} */}
        {/* <Footer1 /> */}
        {/* <FooterContainer/> */}
        {/* </div> */}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // year: state.webApp.year,
    // guestLogin: state.webApp.planDetail,plandetails
    year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
    customerId: state.login.customerId,
    plandetails: state.webApp.plandetails,
    planDetails: state.webApp.planDetail,
    planDetailTable: state.webApp.planDetailTable,
    planType: state.webApp.detailsPlanType,
    productId: state.login.productId,
    cmpnames: state.webApp.cmpnames,
    premiumAmount: state.login.premiumAmount,
    selectedPlanName: state.login.selectedPlanName,
    firstName: state.login.firstName,
    emailAddress: state.login.emailAddress,
    agentLogin: state.login.agentLoggedIn,
    beneficiaryLogin: state.login.beneficiaryLogin,
    email: state.login.agentEmailId,
    token: state.login.token,
    dataSet: state.webApp,
    datadeepLink: state.login,
    zipCode: state.webApp.zip,
    countyName: state.webApp.county,
    stateCd: state.webApp.stateCd,
    CountyCd: state.webApp.CountyCd,
    dpemail: state.login.dpemail,
    productCategory: state.login.productCategory,
    // selectedPlanName: state.login.selectedPlanName,
    lang: state.webApp.language,
    agencyIDSelected: state.login.agencyIDSelected,
    agencyID: state.login.agencyID,
    singlePlanDetails: state.webApp.singlePlanDetails,
    selectedPlansForCompare: state.webApp.selectedPlansForCompare,
    zipCodes: state.webApp.zipCodes,
  };
};
const mapDispatchToProps = {
  guestLogin,
  yearSelection,
  setDeepLink,
  getZipCodes,
  getPlansEmail,
  getAgentIDListInPreEnrollForm,
  planSelectionContinue,
  // removeplan,
  setStateParams,
  setLoginStateParams,
  setFormData,
  comparePlan,
  getPlanDetails,
  getcmpNames,
  setTokenTORedux,
  setPageName,
  setCategoryName,
  getKeyCloakToken,
  getAgencyId,
  getPlans,
  saveAgentDetails
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanSelection);
